module.exports = "<div class=\"activeProgram\">\r\n  <div class=\"activeProgramtitle\">Active Program {{activeProgramNumber}}</div>\r\n  <div class=\"activeProgramItems\" *ngFor=\"let item of list\">\r\n    <div class=\"activeProgramItem\">{{item}}</div>\r\n  </div>\r\n\r\n</div>\r\n<div class=\"activeCodes\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/allPanels/active-program1/active-program1.component.html
// module id = ./src/app/allPanels/active-program1/active-program1.component.html
// module chunks = main